import React, { FC, HTMLAttributes, ReactNode } from 'react'
import { H1, H2, H3, H4, H5, ITitleStyle } from './Title.style'

export interface TitleType extends ITitleStyle {
  children?: ReactNode
  level: number
}

/**
 * @deprecated Заменяй на <Text> из centra ui
 */
const Title: FC<TitleType & HTMLAttributes<HTMLDivElement>> = ({ children, level, ...rest }: TitleType) => {
  switch (level) {
    case 2:
      return <H2 {...rest}>{children}</H2>
    case 3:
      return <H3 {...rest}>{children}</H3>
    case 4:
      return <H4 {...rest}>{children}</H4>
    case 5:
      return <H5 {...rest}>{children}</H5>
    default:
      return <H1 {...rest}>{children}</H1>
  }
}

export default Title
